import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

export default function CustomizedButtons({color, label, onClick, variant , minWidth, marginRight, disabled = false, size = "sm" }) {

  return (
    <Stack direction="row" spacing={2} style={{marginRight:marginRight? marginRight : "10px"}} >
      <Button variant={variant ? variant : "outlined"} color={color} onClick={onClick} sx={{ minWidth: minWidth ? minWidth : variant ? "150px": "auto" }} disabled={disabled} >
        {label}
      </Button>
    </Stack>
  );
}